'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const TShirtIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.1299 10.19C20.9799 9.78 19.4199 5.46 19.1399 4.69C17.6499 4 16.1499 3.3 14.9799 2.75H8.95995C7.78995 3.3 6.28995 3.99 4.79995 4.69C4.20995 6.32 3.45995 8.37 2.79995 10.19C2.68995 10.5 2.85995 10.83 3.17995 10.91C4.10995 11.16 5.09995 11.43 6.07995 11.69V20.25C6.07995 20.8 6.52995 21.25 7.07995 21.25H16.8899C17.4399 21.25 17.8899 20.8 17.8899 20.25V11.69C18.2099 11.6 20.1699 11.08 20.7999 10.91C21.1099 10.82 21.27 10.49 21.16 10.19H21.1299ZM11.9599 5C10.7199 5 9.71995 4 9.71995 2.76H14.1999C14.1999 4 13.1999 5 11.9599 5Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpTShirtIcon = forwardRef(TShirtIcon);

export { VpTShirtIcon as default };
